<section class="home-page insights-page">
  <div class="insights-shell">
    <header class="page-head">
      <div>
        <h1>My time</h1>
        <p>Your hours and project breakdown for the selected period.</p>
      </div>
    </header>

    <div class="filter-row">
      <app-analytics-filters
        [showUser]="false"
        [showProject]="true"
        [projects]="projects()"
        (filterChange)="onFilterChange($event)"
      />
      <span class="result-count">
        {{ rows().length }} {{ rows().length === 1 ? 'project' : 'projects' }}
      </span>
    </div>

    @if (isLoading() && !hasLoaded()) {
      <section class="insights-state" aria-busy="true">
        <p>Pulling your captured hours…</p>
      </section>
    } @else if (!hasProjects()) {
      <section class="insights-state">
        <h2>No accessible projects</h2>
        <p>There are no projects available for this account yet.</p>
      </section>
    } @else {
      <div class="kpi-grid">
        <app-metric-card
          label="Total hours"
          [value]="(totals().total | number: '1.0-1') ?? ''"
          valueSuffix="h"
          [subtitle]="(totals().billable | number: '1.0-1') + ' h billable'"
          iconClass="bi bi-clock-history text-primary"
          [compact]="true"
        />
        <app-metric-card
          label="Approved"
          [value]="(totals().approved | number: '1.0-1') ?? ''"
          valueSuffix="h"
          [subtitle]="(totals().approvedBillable | number: '1.0-1') + ' h billable'"
          iconClass="bi bi-check2-circle text-success"
          [compact]="true"
        />
        <app-metric-card
          label="Pending review"
          [value]="(totals().pending | number: '1.0-1') ?? ''"
          valueSuffix="h"
          [subtitle]="(totals().pendingBillable | number: '1.0-1') + ' h billable'"
          iconClass="bi bi-hourglass-split text-warning"
          [compact]="true"
        />
        <app-metric-card
          label="Entries"
          [value]="filteredEntries().length"
          iconClass="bi bi-list-check text-primary"
          [compact]="true"
        />
      </div>

      <app-insights-charts
        [entries]="filteredEntries()"
        [projects]="projects()"
      />

      <section
        class="project-list project-list--solo card-surface"
        aria-label="Projects"
      >
        <header class="list-head">
          <h2>Projects</h2>
          <app-search-input
            class="list-search"
            ariaLabel="Search projects"
            placeholder="Search projects…"
            [(value)]="projectSearch"
          />
        </header>

        @if (!rows().length) {
          <p class="empty-card">No projects available.</p>
        } @else if (!listedRows().length) {
          <p class="empty-card">
            No projects match "{{ projectSearch().trim() }}".
          </p>
        } @else {
          <div class="list-columns" aria-hidden="true">
            <span>Project</span>
            <span>Approval</span>
            <span>Hours</span>
            <span>Last activity</span>
            <span></span>
          </div>
          @for (row of listedRows(); track row.id) {
            <a
              class="project-row"
              [routerLink]="['/time-sheet']"
              (click)="rememberProject(row.id)"
            >
              <app-project-preview
                class="cell-project"
                [compact]="true"
                [logoUrl]="row.logoUrl"
                [color]="row.color"
                [name]="row.name"
                [description]="row.description"
              />
              <span class="cell-approval">
                <span class="approval-track">
                  <span
                    class="approval-fill"
                    [style.width.%]="row.approvedPercent"
                  ></span>
                </span>
                <small>
                  {{ row.approved | number: '1.0-1' }} approved
                  @if (row.pending) {
                    · {{ row.pending | number: '1.0-1' }} pending
                  }
                </small>
              </span>
              <b class="cell-hours">{{ row.hours | number: '1.0-1' }} h</b>
              <span class="cell-last">
                {{ row.lastActivity ? (row.lastActivity | date: 'mediumDate') : '—' }}
              </span>
              <i class="bi bi-chevron-right chevron" aria-hidden="true"></i>
            </a>
          }
        }
      </section>
    }
  </div>
</section>
